import { AppBar, Box, Button, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHF,
	EnhancedSnackbar,
	RHookFormNumberField,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import {
	CRA_RAMITTANCE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { formatAmountCommaSeperator, formatDate, sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { CRARamittanceDataGrid } from "./CRARamittanceDataGrid";
import { CRARamittanceDataGridWithManagedBySimplePay } from "./CRARamittanceDataGrid/CRARamittanceDataGridWithManagedBySimplePay";
import { CRARamittanceService } from "../../services/CRARamittanceService";
import { ClientRoutesComponent } from "../RoleBasedLeftMenu/routes/ClientRoutes";
import { CountryService } from "../../services/common/CountryService";
import { IAppState } from "../../store/reducers";
import { ICRARamittance } from "../../models/CRARamittance";
import { IGetListRequest } from "../../models";
import { PrimeDataGridWithColumnToggled } from "../PrimeDataGridWithColumnToggled";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { ClientService } from "../../services";
import FileSaver from "file-saver";

// import { CountryService } from "../../services/CountryService";

export interface ICRARamittanceSetup { }

const useCRARamittanceSavedFrequency = (
	clientId: string,
	taxYear: number,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			'cra-remittance-saved-frequency',
		],
		queryFn: (data) => {

			return CRARamittanceService.getCRARamittanceSavedFrequency(
				clientId,
				taxYear,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetRemittanceFrequencyDDL = () =>
	useQuery({
		queryKey: ["remittance-Frequency-ddl"],
		queryFn: (data) => {
			return CRARamittanceService.getRemittanceFrequencyDDL();
		},
		refetchOnWindowFocus: false,
	});

const CRA_RAMITTANCE_LIST_QUERY_KEY = "cra-ramittance-list";

const useCRARamittances = (
	clientId: string,
	remittanceFrequencyId: string | undefined,
	managedBy: number,
	taxYear: number,
	// params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			CRA_RAMITTANCE_LIST_QUERY_KEY,
			clientId,
			remittanceFrequencyId,
			managedBy,
			taxYear,
		],
		queryFn: (data) => {

			return CRARamittanceService.getCRARamittance(
				clientId,
				remittanceFrequencyId,
				managedBy,
				taxYear,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: (data) => {
			return CountryService.getCountryDDL();
		},
		refetchOnWindowFocus: false,
	});


const CLIENT_INFO_DATA_QUERY_KEY = "client-info-data-record";
const useGetClientInformationById = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [CLIENT_INFO_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: (data) => {
			return ClientService.getSimpleClientById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});
export const CRARamittanceSetup: React.FC<ICRARamittanceSetup> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoadinData, setIsLoadinData] = useState(false);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);
	const [craRamittanceSetupTableData, setCRARamittanceSetupTableData] =
		useState([]);
	const [remittanceFrequencyId, setRemittanceFrequencyId] = useState(undefined);
	const [managedBy, setManagedBy] = useState(200);
	const [loadingData, setIsLoading] = useState(false);
	// const companyInformation = useSelector((state: IAppState) => state.dashboardApisData.client_detail)

	const formMethods = useForm<any>({
		// resolver: yupResolver(ValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});
	// const remittanceFrequencyIdField = formMethods.getValues(
	// 	"remittanceFrequencyId"
	// );
	// const managedByField = formMethods.getValues("managedBy");
	// useEffect(() => {
	// 	if (remittanceFrequencyIdField && managedByField) {
	// 		setRemittanceFrequencyId(remittanceFrequencyIdField);
	// 		setManagedBy(managedByField);
	// 	}
	// }, [remittanceFrequencyIdField, managedByField]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { isPending: isPendingCRARamittanceSavedFrequency, data: craRamittanceSavedFrequency }: any = useCRARamittanceSavedFrequency(
		clientIdStore,
		taxYear,
		navigateToLogout
	);

	useEffect(() => {
		// if (craRamittanceSavedFrequency && craRamittanceSavedFrequency.frequencies !== null) {
		if (craRamittanceSavedFrequency) {
			formMethods.setValue(
				"remittanceFrequencyId",
				craRamittanceSavedFrequency.frequencies
			);
			setRemittanceFrequencyId(craRamittanceSavedFrequency.frequencies);
			formMethods.setValue(
				"managedBy",
				craRamittanceSavedFrequency.managedBy
			);
			setManagedBy(craRamittanceSavedFrequency.managedBy);
		}
	}, [craRamittanceSavedFrequency]);

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, data } = useCRARamittances(
		clientIdStore,
		remittanceFrequencyId,
		managedBy,
		taxYear,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const craRamittanceSetup: any | null = data;

	const { isPending: isPendingCountryDDL, data: countryList } =
		useGetCountryDDL();

	const {
		isPending: isPendingRemittanceFrequencyDDL,
		data: remittanceFrequencyDDL,
	} = useGetRemittanceFrequencyDDL();

	const { isPending: isPendingClientInformationById, data: companyInformation } = useGetClientInformationById(
		clientIdStore,
		navigateToLogout
	);

	const updatedRemittanceFrequencyDDL = useMemo(() => {
		if (!remittanceFrequencyDDL) return [];

		return remittanceFrequencyDDL.filter(
			(item: any) => item.label !== "Annual"
		);
	}, [remittanceFrequencyDDL]);


	const { isPending: isSubmitting, mutate: submitCraRemittance } = useMutation({
		mutationFn: CRARamittanceService.create,

		onSuccess: (res: ICRARamittance | IServerError | IResponse | any) => {


			if (res && res.status === 200) {
				queryClient.invalidateQueries({
					queryKey: [CRA_RAMITTANCE_LIST_QUERY_KEY],
				});
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});


	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroCRARamittance, setzeroCRARamittance] = useState(true);
	const [craRamittanceSetupUpdatedItems, setCRARamittanceSetupUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [craRamittanceRowData, setCRARamittanceRowData] = useState<any>(0);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroCRARamittance(false);
	};

	const { isPending: isDeleting, mutate: deleteCRARamittanceById } =
		useMutation({
			mutationFn: CRARamittanceService.delCRARemittance,

			onSuccess: (res: string | IServerError | IResponse) => {
				if (typeof res === "string") {
					// remove the cache of the CRARemittance fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				return queryClient.invalidateQueries({
					queryKey: [CRA_RAMITTANCE_LIST_QUERY_KEY],
				});
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const deleteDepartmentsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				craRamittanceRowData: craRamittanceRowData,
				navigateToLogout: navigateToLogout,
			};
			deleteCRARamittanceById(delPayload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setCRARamittanceRowData(params);
	}, []);

	const onRowEditClicked = useCallback((params: any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/craRamittance/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				// <Box sx={{ marginTop: theme.spacing(1) }}>
				// 	<Button
				// 		onClick={() => onRowMultipleDeleteClicked(selectedItems)}
				// 		variant="contained"
				// 		color="error"
				// 	>
				// 		Delete
				// 	</Button>
				// </Box>
				<></>
			);
		}
		return (
			// <Box sx={{ marginTop: theme.spacing(1) }}>
			// 	<RouterLinkButton to="/craRamittance/setup" text="Add CRARamittance" />
			// </Box>
			<></>
		);
	}, []);
	const upadtedCRARamittanceSetupItems = useMemo(() => {
		if (craRamittanceSetup && craRamittanceSetup.items) {
			const items = [...craRamittanceSetup.items];

			// Find the last item with a non-null remitAmount using binary search
			let left = 0;
			let right = items.length - 1;
			let lastRemittedIndex = -1;

			while (left <= right) {
				let mid = Math.floor((left + right) / 2);
				if (items[mid].remitAmount != null) {
					lastRemittedIndex = mid;
					left = mid + 1; // look for later remitted value
				} else {
					right = mid - 1;
				}
			}

			// Find the first null remitAmount AFTER the last remitted one
			let nextNullIndex = -1;
			for (let i = lastRemittedIndex + 1; i < items.length; i++) {
				if (items[i].remitAmount == null) {
					nextNullIndex = i;
					break;
				}
			}
			// Map and add the two tags
			return items.map((item, index) => ({
				...item,
				// canDelete:
				// 	items[0].remitAmount === null ? false : index === lastRemittedIndex,
				// canEdit: items[0].remitAmount === null ? true : index === nextNullIndex,
				canDelete: index === lastRemittedIndex,
				canEdit: index === nextNullIndex,

				// dueDoller: formatAmountCommaSeperator(item.dueDoller),
				// dueAmount: formatAmountCommaSeperator(item.dueAmount),
				// craCredit: formatAmountCommaSeperator(item.craCredit),
			}));
		}
	}, [craRamittanceSetup]);



	const expandedLabels = ["Taxes", "Remittance"];
	const expandedCRARamittanceSetupOrSetupItem = "CRA"; // Special case for "List" under "CRARamittance"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Remittance" &&
				item.label === expandedCRARamittanceSetupOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedCRARamittanceSetupOrSetupItem && "/taxes/remittance/cra",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: CRA_RAMITTANCE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	const onSubmitButtonClickedHandler = () => {


		const updatePayloadData =
			craRamittanceSetupTableData &&
			craRamittanceSetupTableData.map((item: any) => ({
				...item,
				chequeDate: formatDate(item.chequeDate),
			}));

		const EditedRowData = updatePayloadData.filter((item: any) => item.canEdit)
		submitCraRemittance({ data: [EditedRowData[0]] })
	};

	const onSubmit = (values: any) => {

	};
	const onRemittanceFrequencyChangeHandler = async (selectedItem: any) => {
		if (craRamittanceSavedFrequency && craRamittanceSavedFrequency.frequencies === null) {
			(async () => {
				setIsLoadinData(true)
				try {
					const responce = await CRARamittanceService.createCraRemittanceFrequency(
						clientIdStore,
						selectedItem.value,
						managedBy,
						taxYear,
						navigateToLogout
					)

				}
				catch {

				} finally {
					queryClient.invalidateQueries({
						queryKey: [
							'cra-remittance-saved-frequency'
						],
					});
					setRemittanceFrequencyId(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							CRA_RAMITTANCE_LIST_QUERY_KEY,
							clientIdStore,
							selectedItem.value,
							managedBy,
							taxYear,
						],
					});
					setIsLoadinData(false)
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		} else if (selectedItem.value) {
			// setRemittanceFrequencyId(selectedItem.value);
			// queryClient.invalidateQueries({
			// 	queryKey: [
			// 		CRA_RAMITTANCE_LIST_QUERY_KEY,
			// 		clientIdStore,
			// 		selectedItem.value,
			// 		managedBy,
			// 		taxYear,
			// 	],
			// });
			(async () => {
				setIsLoadinData(true)
				try {
					const responce = await CRARamittanceService.createCraRemittanceFrequency(
						clientIdStore,
						selectedItem.value,
						managedBy,
						taxYear,
						navigateToLogout
					)

				}
				catch {

				} finally {
					setIsLoadinData(false)
					setRemittanceFrequencyId(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							CRA_RAMITTANCE_LIST_QUERY_KEY,
							clientIdStore,
							selectedItem.value,
							managedBy,
							taxYear,
						],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		}
	};
	const onManagedByChangeHandler = (selectedItem: any) => {
		// setManagedBy(selectedItem.value);
		// queryClient.invalidateQueries({
		// 	queryKey: [
		// 		CRA_RAMITTANCE_LIST_QUERY_KEY,
		// 		clientIdStore,
		// 		remittanceFrequencyId,
		// 		selectedItem.value,
		// 		taxYear,
		// 	],
		// });
		if (craRamittanceSavedFrequency && craRamittanceSavedFrequency.managedBy === null) {
			(async () => {
				setIsLoadinData(true)
				try {
					const responce = await CRARamittanceService.createCraRemittanceFrequency(
						clientIdStore,
						remittanceFrequencyId,
						selectedItem.value,
						taxYear,
						navigateToLogout
					)

				}
				catch {

				} finally {
					queryClient.invalidateQueries({
						queryKey: [
							'cra-remittance-saved-frequency'
						],
					});
					setManagedBy(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							CRA_RAMITTANCE_LIST_QUERY_KEY,
							clientIdStore,
							remittanceFrequencyId,
							selectedItem.value,
							taxYear,
						],
					});
					setIsLoadinData(false)
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		} else if (selectedItem.value) {
			(async () => {
				setIsLoadinData(true)
				try {
					const responce = await CRARamittanceService.createCraRemittanceFrequency(
						clientIdStore,
						remittanceFrequencyId,
						selectedItem.value,
						taxYear,
						navigateToLogout
					)

				}
				catch {

				} finally {
					setIsLoadinData(false)
					setManagedBy(selectedItem.value);
					queryClient.invalidateQueries({
						queryKey: [
							CRA_RAMITTANCE_LIST_QUERY_KEY,
							clientIdStore,
							remittanceFrequencyId,
							selectedItem.value,
							taxYear,
						],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				}
			})();
		}
	};

	const balanceAmount = (value: number) => {
		if (value < 0) {
			
			return (
				<>
					<span style={{ color: "red" }}>
						{formatAmountCommaSeperator(value)}
					</span></>
			);
		} else {
			return (
				<span>
					{formatAmountCommaSeperator(value)}
				</span>
			);
		}
	};


	// getting latest updated values of form fields using watch method
	const { watch } = formMethods;
	const values = watch([
		"remittanceFrequencyId",
		"managedBy",
	]);

	const savePdfAsFile = (xmlData: any, filename: any) => {
		const blob = new Blob([xmlData], { type: "pdf;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};

	const onExportButtonClick = async () => {
		const [remittanceFrequencyId, managedBy] = values;

		try {
			setIsLoading(true);
			const response = await CRARamittanceService.exportCraRemittanceExcelReport(
				clientIdStore,
				remittanceFrequencyId,
				taxYear,
				managedBy,
			);

			if (response) {
				if (response.status === 400) {
					setSnackbarData({
						open: true,
						message: response.data.message
							? response.data.message
							: "Something went wrong.",

						severity: "error",
					});
				} else {
					const filename = `CRA-Remittance.xlsx`;
					savePdfAsFile(response, filename);
				}
			} else {
				console.error("Error: No data received from the server");
			}
		} catch (err) {
			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}
	};

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_craRamittance_list.png";

	return (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}

				sx={{
					mt: "1rem"
				}}>
				<BackdropCircularProgress
					open={isPending || isPendingClientInformationById || isPendingRemittanceFrequencyDDL || isSubmitting || isPendingCRARamittanceSavedFrequency || isLoadinData || isDeleting || loadingData}
					testId="craRamittance-list"
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteDepartmentsField}
					cancelActionHandler={onCloseHandler}
					testId="departments-confirmation-dialog"
				/>
				<FormProvider {...formMethods}>
					<form onSubmit={formMethods.handleSubmit(onSubmit)}>
						<Grid
							container
							size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
							sx={{
								background: "#fff",
								border: "1px solid #e5e7eb",
								borderBottom: 0,
								borderRadius: "2px 2px 0 0",
								padding: "15px",
							}}
						>
							<Grid
								size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
								sx={{ mt: "12px" }}
							>
								<EnhancedDropDownRHF
									selectName="remittanceFrequencyId"
									testId={`remittanceFrequency-list`}
									items={updatedRemittanceFrequencyDDL && sortDDLByLabel(updatedRemittanceFrequencyDDL ?? [])}
									showEmpty
									selectedItem={null}
									// selectedItem={remittanceFrequencyDDL && remittanceFrequencyDDL[0].value}
									onSelectionChangeHandler={onRemittanceFrequencyChangeHandler}
									isDisabled={
										craRamittanceSetup && craRamittanceSetup.items && craRamittanceSetup.items.some((item: any) => item.status === 'Remitted') ? true : false}
								/>
								<EnhancedDropDownRHF
									selectName="managedBy"
									testId={`managed_by-list`}
									items={
										companyInformation && companyInformation.paymentSetup === 100 ?
											[{ label: "Self Managed", value: 200 }] :
											[
												{ label: "Managed by Simplepay", value: 100 },
												{ label: "Self Managed", value: 200 },
											]}
									isDisabled={companyInformation && companyInformation.paymentSetup === 100 ? true : false}
									selectedItem={200}
									onSelectionChangeHandler={onManagedByChangeHandler}
								/>
								{/* <EnhancedDropDownRHF
									selectName="premiums"
									testId={`premiums-list`}
									items={[]}
									// selectedItem={}
									// onSelectionChangeHandler={onRemittanceFrequencyChangeHandler}
								/> */}
							</Grid>
							<Grid
								size={{ xs: 12, sm: 2, md: 1, lg: 1, xl: 1 }}
								sx={{ marginTop: "auto", marginLeft: "5px" }}
							>
								{/* <RHookFormNumberField id="premuimsNumber" testId={`number`} /> */}
							</Grid>
							<Grid size={{ xs: 0, sm: 0, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
							<Grid
								size={{ xs: 12, sm: 3, md: 1.5, lg: 1.5, xl: 1.5 }}
								sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}
							>
								Total Due {
									craRamittanceSetup && craRamittanceSetup.headerColumns?.find((x: any) => x.field === 'dueAmount')?.footer
										? formatAmountCommaSeperator(
											craRamittanceSetup.headerColumns.find((x: any) => x.field === 'dueAmount').footer
										)
										: '0.00'
								}
								<br /> Total Remitted
								{
									craRamittanceSetup && craRamittanceSetup.headerColumns?.find((x: any) => x.field === 'remitAmount')?.footer
										? formatAmountCommaSeperator(
											craRamittanceSetup.headerColumns.find((x: any) => x.field === 'remitAmount').footer
										)
										: '0.00'
								}
								<br />
								YTD Due  <br />
								YTD Remitted  <br />
								Balance {
									craRamittanceSetup && craRamittanceSetup.headerColumns?.find((x: any) => x.field === 'shortExcess')?.footer
										? balanceAmount(
											craRamittanceSetup.headerColumns.find((x: any) => x.field === 'shortExcess').footer
										)
										: '0.00'
								}
							</Grid>
							<Grid
								size={{ xs: 0, sm: 0, md: 4.95, lg: 4.95, xl: 4.95 }}
							></Grid>
							<Grid
								size={{ xs: 12, sm: 3, md: 2, lg: 2, xl: 2 }}
								sx={{
									textAlign: "right",
									color: "rgba(0, 0, 0, 0.6)",
									fontSize: "0.875rem",
								}}
							>
								{companyInformation && companyInformation.craBusinessNo?.replace(/\s*RP\s*/g, " RP ")} <br />
								<Link
									to={`/taxes/remittance/cra-credit`}
									className="no-underline"
									style={{ color: theme.palette.primary.light }}
								// onClick={}
								>
									Available CRA Credit:
								</Link>
								{" "}
								<span style={{ fontWeight: "bold" }}>{craRamittanceSetup && formatAmountCommaSeperator(craRamittanceSetup?.craCreditAvailableAmount)}</span>
								<br />

								<Link
									to={`#`}
									className="no-underline"
									style={{ color: theme.palette.primary.light }}
								// onClick={onExportButtonClick}
								>
									Tax services offices and tac centers

								</Link> <br />
								<Link
									to={`#`}
									className="no-underline"
									style={{ color: theme.palette.primary.light }}
									onClick={onExportButtonClick}
								>
									Export to excel
								</Link>

							</Grid>
						</Grid>
					</form>
				</FormProvider>
				{managedBy !== 100 ? (
					<CRARamittanceDataGrid
						columns={craRamittanceSetup ? craRamittanceSetup.headerColumns : []}
						rows={
							craRamittanceSetup && upadtedCRARamittanceSetupItems
								? upadtedCRARamittanceSetupItems
								: []
						}
						showIndexColumn={true}
						showChecboxColumn={isAdminUser === 400 ? true : false}
						// showSettingColumn={true}
						// onRowEditClicked={onRowEditClicked}
						onRowDeleteClicked={onRowDeleteClicked}
						onSnackbarMessageData={(value: any) => setSnackbarData(value)}
						totalRecords={
							craRamittanceSetup && craRamittanceSetup.total
								? craRamittanceSetup.total
								: 0
						}
						initialPageSize={INITIAL_PAGE_SIZE}
						rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
						onRequestParamsChange={onRequestParamsChange}
						selectionToolbar={selectionToolbar}
						selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
						searchFieldPlaceholder={"Search..."}
						changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
							setzeroCRARamittance(value)
						}
						pageTitle={"CRARamittance"}
						craRamittanceSetupTableData={(data: any) =>
							setCRARamittanceSetupTableData(data)
						}
						tableMargin={"0"}
					/>
				) : (
					<CRARamittanceDataGridWithManagedBySimplePay
						columns={craRamittanceSetup ? craRamittanceSetup.headerColumns : []}
						rows={
							craRamittanceSetup && upadtedCRARamittanceSetupItems
								? upadtedCRARamittanceSetupItems
								: []
						}
						showIndexColumn={true}
						tableMargin={"0"}
					/>
				)}

				{craRamittanceSetup && craRamittanceSetup.items && managedBy === 200 && (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							// backgroundColor: "#fff",
							backgroundColor: "#F7F7F7",
							// marginTop: theme.spacing(3),
							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					>
						<Toolbar>
							<EnhancedButtonPrimeReact
								label="Submit"
								// type="submit"
								onClickHandler={onSubmitButtonClickedHandler}
								// icon="pi pi-check"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
							/>
						</Toolbar>
					</AppBar>
				)}
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
